__turbopack_context__.v({
  "input": "otpInput-module-scss-module__Tc8nwG__input",
  "isError": "otpInput-module-scss-module__Tc8nwG__isError",
  "large": "otpInput-module-scss-module__Tc8nwG__large",
  "medium": "otpInput-module-scss-module__Tc8nwG__medium",
  "small": "otpInput-module-scss-module__Tc8nwG__small",
  "wrapper": "otpInput-module-scss-module__Tc8nwG__wrapper",
});
